import { useState } from 'react';

import { SettingsLanguageEndpoint } from '@core/types/types.endpoint.settings';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@frontend/components/ui/select';
import { LANGUAGES } from '@frontend/Settings/const/Settings.const.LANGUAGES';
import { useDirectoryUpdater } from '@frontend/shared/hooks/shared.hook.useDirectoryUpdater';
import { useDirectoryTeam } from '@frontend/shared/hooks/useDirectory';
import { useSubmitter } from '@frontend/shared/hooks/useSubmitter';
import { callApi } from '@frontend/shared/util/util.callApi';

interface SettingsLanguageProps {
  isReadOnly?: boolean;
}

export function SettingsLanguage({
  isReadOnly = false,
}: SettingsLanguageProps) {
  const team = useDirectoryTeam();
  const [language, setLanguage] = useState(team.primary_language ?? 'English');
  const updater = useDirectoryUpdater();
  const submitter = useSubmitter(async (language: string) => {
    const [err, res] = await callApi<SettingsLanguageEndpoint>(
      `/settings/language`,
      {
        language,
      },
    );
    if (!res || err) {
      setLanguage(team.primary_language ?? 'English');
    }
    if (res) {
      updater({ team: res });
    }
  });

  return (
    <div className="flex items-center">
      <div>
        <h3 className="text-xs font-semibold">Documentation Language</h3>

        <p className="mt-1 text-xs font-medium text-gray-500">
          Automatically translate answers to this language.
        </p>
      </div>
      <Select
        value={language}
        onValueChange={(value) => {
          if (!isReadOnly) {
            setLanguage(value);
            submitter.submit(value);
          }
        }}
        disabled={isReadOnly || submitter.isSubmitting}
      >
        <SelectTrigger size="sm" className="ml-auto w-auto max-w-[200px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {LANGUAGES.map((l) => (
            <SelectItem key={l} value={l}>
              {l}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
